import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';
import { CurrencyPipe } from './currency.pipe';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[currencyFormatter]'
})
export class CurrencyFormatterDirective implements OnInit {

  private el: any;

  constructor(
    private elementRef: ElementRef,
    private currencyPipe: CurrencyPipe
  ) {
    this.el = this.elementRef.nativeElement;
  }

  ngOnInit() {
    const vm = this;
    setTimeout(() => {
      vm.el.value = vm.currencyPipe.transform(vm.el.value);
    }, 10);
  }

  @HostListener('focus', ['$event.target.value'])
  onFocus(value) {
    this.el.value = this.currencyPipe.parse(value);
  }

  @HostListener('blur', ['$event.target.value'])
  onBlur(value) {
    this.el.value = this.currencyPipe.transform(value);
  }

}
